import React, { useState } from "react";
import "../App.css";
import Tabs from "./Tabs";
import { Footer } from "./Footer";

const Body = ({ authenticate }) => {
  const [pageCount, setPageCount] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const onPageChange = (pageNumber) => {
    setPageNumber(pageNumber);
  };

  return (
    <>
      <Tabs
        authenticate={authenticate}
        pageCount={pageCount}
        setPageCount={setPageCount}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
      />
      <Footer
        pageCount={pageCount}
        pageNumber={pageNumber}
        onPageChange={onPageChange}
      />
    </>
  );
};

export default Body;
